module.exports = __webpack_public_path__ + "static/Solution_Ad2-d33d549fa2b54c56103ad2c74766513b.png";